// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjOGuV2Lr1qZpGYT7NZ80ygq7yqJYpDOU",
  authDomain: "recruit-flaretech.firebaseapp.com",
  projectId: "recruit-flaretech",
  storageBucket: "recruit-flaretech.firebasestorage.app",
  messagingSenderId: "58792631102",
  appId: "1:58792631102:web:1245513875d3a753ea6a6f",
  measurementId: "G-R7YL6J69B4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Initialize Authentication
const auth = getAuth(app);

export { app, analytics, db, storage, auth };
